export default __webpack_public_path__ + "static/media/function.03e50d80.gif";